import { createFileRoute, Outlet } from '@tanstack/react-router';
import { requireRole } from '../lib/auth-guard.js';

// Layout-Route für /admin/assignments. Rendert NUR die Kind-Routen via <Outlet/>:
// die Liste liegt in admin.assignments.index.tsx, das Detail in admin.assignments.$id.tsx.
export const Route = createFileRoute('/admin/assignments')({
  component: AdminAssignmentsLayout,
  beforeLoad: async ({ context }) => {
    await requireRole(context.queryClient, ['ceo', 'internal_staff']);
  },
});

function AdminAssignmentsLayout() {
  return <Outlet />;
}
